import Tooltip from "./Tooltip";
import InfoTip from "./InfoTip";
import { TooltipDirection } from "./TooltipTypes";

type TooltipComponent = typeof Tooltip & {
  Direction: typeof TooltipDirection;
  InfoTip: typeof InfoTip;
};

const Component = Tooltip as TooltipComponent;
Component.Direction = TooltipDirection;
Component.InfoTip = InfoTip;

export default Component;
